// VIP会员模块
const getDefaultState = () => {
	return {
		vipLevel: null // PTHY: 普通会员, VIP: 高级会员, SVIP: 超级会员
	}
}

const state = getDefaultState()

const mutations = {
	SET_VIPLEVEL: (state, vipLevel) => {
		state.vipLevel = vipLevel
	}
}

const actions = {
	setVipLevel({ commit }, vipLevel) {
		commit('SET_VIPLEVEL', vipLevel)
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
